// extracted by mini-css-extract-plugin
export default {"list":"list-ZGGfe","createSubjectItem":"createSubjectItem-Y3eRS","createSubjectItemDisabled":"createSubjectItemDisabled-QHjcb"};